export const toastConfig = () => {
  return {
    // root: {
    //   width: '28rem',
    //   summaryFontSize: '2.2rem',
    //   summaryFontWeight: '700',
    //   detailFontSize: '1.8rem',
    //   iconSize: '2rem',
    //   contentGap: '.8rem',
    //   contentPadding: '1rem 0.9rem',
    // }
    width: '34rem',
    contentGap: '.8rem',
    contentPadding: '1rem 0.9rem',
    summary: {
      font: {
        size: '1.4rem',
        weight: '500'
      }
    },
    detail: {
      font: {
        size: '1.2rem',
        weight: '500'
      }
    },
    icon: {
      size: '1.8rem'
    }
  }
}
